/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

import uuid from "uuid/v4";
import axios from "axios";

import { enforceHttps, parseQueryString, serializeQueryParams } from "util/uri";
import env from "util/env";

import Cookies from "js-cookie";

const defaultEndpoint = env("ZUU_CONSOLE_API_ENDPOINT");

function makeUri(path = "") {
    const _window = window || {};
    const location = _window.location || {};
    const { protocol, host } = location;
    return `${protocol}//${host}${path}`;
}

export function nonce() {
    const data = {};
    const random = uuid();
    data[random] = {
        redirectUri: window.location.pathname + window.location.search,
    };
    const str = window.btoa(JSON.stringify(data));
    localStorage.setItem("auth_state", str);
    return str;
}

export function tokenHasExpired() {
    let token = localStorage.getItem("access_token");
    if (!token) return true;
    let expiresAt = localStorage.getItem("expires_at");
    return new Date().getTime() > expiresAt;
}

export function processAuthCodeCallback(service) {
    return new Promise((resolve, reject) => {
        const query = parseQueryString(window.location.search);
        const state = localStorage.getItem("auth_state");
        const validState = state && state === query.state;
        if (!validState) reject("Invalid auth state");
        const params = serializeQueryParams({
            code: query.code,
            redirectUri: makeUri("/auth"),
            service,
        });
        const url = enforceHttps(`${defaultEndpoint}/auth/token?${params}`);
        axios({ method: "get", url })
            .then((result) => {
                resolve(result.data.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function setSession(result) {
    // Set the time that the access token will expire at
    const accessToken = result.accessToken || result.access_token;
    const expiresIn = result.expiresIn || result.expires_in;
    let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
    localStorage.removeItem("auth_state");
    localStorage.setItem("access_token", accessToken);
    localStorage.setItem("expires_at", expiresAt);
    Cookies.set("access_token", accessToken);

    //const idToken = result.idToken || result.id_token;
    //localStorage.setItem("id_token", idToken);
}
